// extracted by mini-css-extract-plugin
export default {"page":"NR-z","cartModal":"OR-z","checkout":"PR-z","placeholder":"QR-z","account":"RR-z"};